//main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import LocalStorage from './utils/localStorage';

import './main.css'

// 引入vant
import Vant from "vant";
import 'vant/lib/index.css';
Vue.use(Vant);
import { Toast } from 'vant';
Vue.prototype.$toast = Toast;


// 移动端适配
import 'amfe-flexible';

Vue.prototype.$localStorage = LocalStorage;

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$bus = new Vue({})

import Tabbar from "@/components/Tabbar";
import BackTop from "@/components/BackTop";
import Service from "@/components/Service";
import Footer from "@/components/Footer";
Vue.component('Tabbar', Tabbar)
Vue.component('BackTop', BackTop)
Vue.component('Service', Service)
Vue.component('Footer', Footer)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
